// Los controles que una PANTALLA pone en el topbar, junto a su título.
//
// No son las `actions` del `AppShell`: esas son del PORTAL (las declara la ruta que monta el shell)
// y van a la derecha. Estos son de una pantalla concreta y van pegados a su título, que es donde el
// mock pone el alcance sobre el que la pantalla mira.
//
// Va por portal y no por prop porque el shell lo monta la ruta padre y la pantalla es su `Outlet`:
// la misma razón por la que `useScreenTitle` existe.
import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';
import { create } from 'zustand';

interface ScreenControlsState {
    /** El hueco del topbar. Es un elemento del DOM, así que su identidad no cambia por render. */
    slot: HTMLElement | null;
    setSlot: (slot: HTMLElement | null) => void;
}

export const useScreenControlsStore = create<ScreenControlsState>((set) => ({
    slot: null,
    setSlot: (slot) => {
        set({ slot });
    },
}));

/** Monta sus hijos en el topbar del shell. Sin shell alrededor no pinta nada, y no revienta. */
export function ScreenControls({ children }: { children: ReactNode }) {
    const slot = useScreenControlsStore((state) => state.slot);
    if (slot === null) return null;
    return createPortal(children, slot);
}
